import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  courses: [],
  currentCourse: null,
  loading: false,
  error: null,
  pagination: {
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 0
  },
  filters: {
    search: '',
    status: 'all',
    category: 'all'
  }
}

const coursesSlice = createSlice({
  name: 'courses',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
    },
    setCourses: (state, action) => {
      state.courses = action.payload
    },
    setCurrentCourse: (state, action) => {
      state.currentCourse = action.payload
    },
    addCourse: (state, action) => {
      state.courses.push(action.payload)
    },
    updateCourse: (state, action) => {
      const index = state.courses.findIndex(course => course.id === action.payload.id)
      if (index !== -1) {
        state.courses[index] = action.payload
      }
    },
    removeCourse: (state, action) => {
      state.courses = state.courses.filter(course => course.id !== action.payload)
    },
    setPagination: (state, action) => {
      state.pagination = { ...state.pagination, ...action.payload }
    },
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload }
    },
    clearError: (state) => {
      state.error = null
    }
  }
})

export const {
  setLoading,
  setError,
  setCourses,
  setCurrentCourse,
  addCourse,
  updateCourse,
  removeCourse,
  setPagination,
  setFilters,
  clearError
} = coursesSlice.actions

export default coursesSlice.reducer